import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PbdcBeneficioTemporarioComponent } from '../pbdc-beneficio-temporario/pbdc-beneficio-temporario.component';
import { PbdcFundoPrevidencialComponent } from '../pbdc-fundo-previdencial/pbdc-fundo-previdencial.component';
import { PbdcReservaPoupancaComponent } from '../pbdc-reserva-poupanca/pbdc-reserva-poupanca.component';
import { PbdcSuperavitComponent } from '../pbdc-superavit/pbdc-superavit.component';
import { PbdcDashboardComponent } from '../pbdc-dashboard/pbdc-dashboard.component';

const pbdcRoutes = [
    { path: 'plano/fundorev', component: PbdcFundoPrevidencialComponent },
    { path: 'plano/ReservaPou', component: PbdcReservaPoupancaComponent },
    { path: 'plano/superavit', component: PbdcSuperavitComponent },
    { path: 'plano/benTemp', component: PbdcBeneficioTemporarioComponent },
    { path: 'plano/dashboard', component: PbdcDashboardComponent },

];

@NgModule({
    imports: [RouterModule.forChild(pbdcRoutes)],
    exports: [RouterModule]
})
export class PbdcRoutingModule {


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/router/pbdc.router.ts